module.exports = __webpack_public_path__ + "img/29_58.bc817f42.png";